<template>
  <footer>
    <a href="http://www.leucemie-espoir.org" class="fle"></a>
    
    <a class="button btnPush btTop js-scrollTo" href="#app"><i class="fas fa-angle-double-up"></i></a>
    <router-link :to="{ name: 'suggestion' }" class="button btnPush btTop beta" title="Suggestion"><i class="fas fa-comment-alt"></i></router-link>
    
    <div class="mask">
      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="large-4 medium-4 small-12 cell txt">
            <router-link :to="{ name: 'home' }" title="Globulo Quest"><img src="@/assets/images/globulo-quest-blanc.png" alt="Globulo Quest Logo" title="Globulo Quest"/></router-link>
              <p><strong>Globulo Quest</strong> est un programme gamifié de suivi du parcours de soins de jeunes enfants atteints de leucémie, à vocation d'éducation thérapeutique.
              </br>
              Nous avons imaginé un concept de jeu en espérant répondre aux besoins de ces enfants ainsi que de leurs parents, proches et soignants: comprendre la maladie, préparer et dédramatiser les rendez-vous à l'hôpital, créer du lien avec le personnel soignant et le garder même à distance, impliquer la famille et les proches au sein d’une communauté autour de l’enfant.
             </p>
            </div>
          <div class="large-4 medium-4 small-12 cell">
            <ul class="list">
              <li><router-link :to="{ name: 'about' }" title="A propos de Globulo Quest">A propos</router-link></li> 
              <li><router-link :to="{ name: 'partenaires' }" title="">Partenaires</router-link></li> 
              <li><router-link :to="{ name: 'follow_us' }" title="">Suivez-nous</router-link></li> 
              <li><router-link :to="{ name: 'contact_us' }" title="Contact Globulo Quest">Contactez-nous</router-link></li>
              <li><router-link :to="{ name: 'faq' }" title="FAQ">FAQ</router-link></li>
              <li><router-link :to="{ name: 'signupCaregiver' }" title="FAQ">Inscription soignant</router-link></li>
              <li><a target="_blank" href="/globulo_quest-le-chemin-vers-la-guerison-2020-2.pdf" title="Dossier de presse">Dossier de presse</a></li>
              <li><a target="_blank" href="/flyer_globulo_quest-2020.pdf" title="Flyer">Flyer</a></li>
              <li><a target="_blank" href="https://globuloquest.typeform.com/to/hiBHgi#account_email=xxxxx">Sondage</a></li>
            </ul>
          </div>
          <div class="large-4 medium-4 small-12 cell">
            <form class="newsletter">
              <template v-if="thx">
                <p>Merci pour votre inscription à notre newsletter !</p>
                <p>Attendez-vous à recevoir de nos nouvelles très bientôt.</p>
              </template>
              <template v-else>
              <p>Recevez notre lettre d’information et ne ratez aucune infos !</p>
              <input type="email" name="email-newsletter" id="email-newsletter" placeholder="Entrez votre e-mail" v-model="email"/>
              <a class="button btnPush" @click="send">Je m’abonne !</a>
              </template>
            </form>
          </div>
        </div>
      </div>
      <div class="bottomBar">
        <div class="row">
          <p class="left">Tous droits réservés {{ new Date().getFullYear() }} - Globulo Quest - <a href="mentions-legales" title="">Mentions légales</a></p>
          <ul>
            <li><a href="https://www.facebook.com/GlobuloQuest/" title=""><i class="fab fa-facebook"></i></a></li>
            <!--<li><a href="" title=""><i class="fab fa-twitter-square"></i></a></li>-->
            <li><a href="https://www.linkedin.com/company/globuloquest-le-chemin-vers-la-gu%C3%A9rison/" title=""><i class="fab fa-linkedin"></i></a></li>
          </ul>
          <p class="right"> <i class="fas fa-heart"></i> Lauréats du 2nd prix de la fondation B. Braun 2017 </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    data() {
      return {
        email: '',
        thx: false
      }
    },
    methods: {
      ...mapActions(['sendNewsletter']),
      async send (e) {
        e.preventDefault();

        try {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(String(this.email).toLowerCase())) {
            this.$store.dispatch('addError', {message: `Veuillez entrer un email valide`})
            throw 'Bad Email'
          }

          this.sendNewsletter({ email: this.email })
          this.email = ''
          this.thx = true
        } catch(ex) {
        }
      }
    }
  }
</script>
